import docxIcon from '/assets/images/docx_icon.svg';
import fileIcon from '/assets/images/file.png';
import gifIcon from '/assets/images/gif_icon.svg';
import mediaIcon from '/assets/images/media_icon.svg';
import oftIcon from '/assets/images/oft_icon.svg';
import pdfIcon from '/assets/images/pdf_icon.svg';
import pictureIcon from '/assets/images/picture_icon.svg';
import pptxIcon from '/assets/images/pptx_icon.svg';
import xlsxIcon from '/assets/images/xlsx_icon.svg';

type FileExtension = 'pdf' | 'doc' | 'docx' | 'oft' | 'ppt' | 'pptx' | 'xls' | 'xlsx' | 'jpg' | 'jpeg' | 'png' | 'gif' | 'tif' | 'eps' | 'svg' | 'mp3' | 'wav' | 'mov';

export const getFileIcon = (filename: string): string => {
  const fileExtension = getFileExtension(filename);
  if (fileExtension === 'ppt' || fileExtension === 'pptx') return pptxIcon;
  else if (fileExtension === 'doc' || fileExtension === 'docx') return docxIcon;
  else if (fileExtension === 'xls' || fileExtension === 'xlsx') return xlsxIcon;
  else if (fileExtension === 'gif') return gifIcon;
  else if (fileExtension === 'oft') return oftIcon;
  else if (fileExtension === 'pdf') return pdfIcon;
  else if (fileExtension === 'jpg' || fileExtension === 'jpeg' || fileExtension === 'png' || fileExtension === 'svg') return pictureIcon;
  else if (fileExtension === 'mp3' || fileExtension === 'wav' || fileExtension === 'mov') return mediaIcon;
  else return fileIcon;
}

const getFileExtension = (filename: string): FileExtension => {
  return filename.split('.').pop() as FileExtension;
}